const maxAllowedChars: any = {
  rfc: 13,
  rfc_company: 12,
  curp: 18,
  phone: 10,
  job_reference_phone: 10,
  last_landlord_phone: 10,
  postal_code: 5,
  business_activity: 60,
  // "Otro" free-text for occupation goes verbatim into the contract — keep it short.
  occupation: 30,
};

export const getMaxAllowedChars = (type: string) => {
  if (!maxAllowedChars[type]) return;

  return {
    max: maxAllowedChars[type],
    show: true,
  };
};
